import { BottomNavigation, BottomNavigationAction, Container, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useEffect, useState } from 'react';
import { BsClockHistory, BsFillLightningChargeFill, BsLightningCharge, BsTrophy } from 'react-icons/bs';
import { useHistory, useLocation } from 'react-router-dom';

import '../../styles/navigationBar.scss';

export default function NavigationBar() {

    const history = useHistory();
    const location = useLocation();
    const [page, setPage] = useState(location.pathname);

    useEffect(() => {
        console.log(page)
        history.push(page)
    }, [page])

    return(
        <Container className = "container">
            <BottomNavigation className = "navigationBar"
                value={location.pathname}
                onChange={(event, pageNumber) => {
                    setPage(pageNumber)
                }}>
                <BottomNavigationAction className="navBarItem" label="Statistics" value={'/leaderboard'} icon={<BsTrophy/>}/>
                <BottomNavigationAction className="navBarItem" label="Charging" value={'/session'} icon={<BsLightningCharge/>}/>
                <BottomNavigationAction className="navBarItem" label="History" value={'/history'} icon={<BsClockHistory/>}/>
            </BottomNavigation>
        </Container>
    );
};
